import { Link } from "react-router-dom";
import { Instagram, Youtube, Phone, MapPin, Mail } from "lucide-react";
import Logo from "@/components/Logo";
import { useCentre } from "@/context/CentreContext";

const YOUTUBE_URL = "https://www.youtube.com/@HorsePowerGarage/videos";

export default function Footer() {
  const { centres, current } = useCentre();
  return (
    <footer className="bg-hp-dark border-t border-white/10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 grid gap-12 md:grid-cols-4">
        <div>
          <Logo imgClass="h-12" />
          <p className="text-white/55 text-sm mt-5 leading-relaxed font-light3">
            Réseau national spécialisé en reprogrammation moteur, conversion E85 FlexFuel et préparation automobile.
          </p>
          <div className="flex gap-3 mt-5">
            <a href={current?.instagram || "https://www.instagram.com/horsepower_garage"} target="_blank" rel="noopener noreferrer" className="h-9 w-9 grid place-items-center border border-white/15 hover:border-hp-gold hover:text-hp-gold transition-colors" aria-label="Instagram"><Instagram size={17} /></a>
            <a href={YOUTUBE_URL} target="_blank" rel="noopener noreferrer" className="h-9 w-9 grid place-items-center border border-white/15 hover:border-hp-gold hover:text-hp-gold transition-colors" aria-label="YouTube"><Youtube size={17} /></a>
          </div>
        </div>

        <div>
          <h4 className="font-display uppercase text-sm tracking-widest text-hp-gold mb-4">Navigation</h4>
          <ul className="space-y-2.5 text-sm text-white/55 font-light3">
            <li><Link to="/reprogrammation" className="hover:text-white">Reprogrammation</Link></li>
            <li><Link to="/services/e85" className="hover:text-white">Conversion E85</Link></li>
            <li><Link to="/services/banc-de-puissance" className="hover:text-white">Banc de puissance</Link></li>
            <li><Link to="/realisations" className="hover:text-white">Réalisations</Link></li>
            <li><Link to="/nous-connaitre" className="hover:text-white">Nous connaître</Link></li>
            <li><Link to="/devenir-franchise" className="hover:text-white">Devenir franchisé</Link></li>
            <li><a href="https://horsepower-academy.com/" target="_blank" rel="noopener noreferrer" className="hover:text-white">Formation reprogrammation</a></li>
            <li><a href="https://horsepowertuningfiles.com/" target="_blank" rel="noopener noreferrer" className="hover:text-white">File Service pro</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display uppercase text-sm tracking-widest text-hp-gold mb-4">Nos centres</h4>
          <ul className="space-y-2.5 text-sm text-white/55 font-light3">
            {centres.map((c) => (
              <li key={c.slug}><Link to={`/centres/${c.slug}`} className="hover:text-white">{c.city}{c.is_mother ? " — Maison mère" : ""}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display uppercase text-sm tracking-widest text-hp-gold mb-4">{current ? current.name : "Contact"}</h4>
          <ul className="space-y-3 text-sm text-white/55 font-light3">
            {current?.postal_city && <li className="flex items-start gap-2"><MapPin size={16} className="text-hp-gold mt-0.5 shrink-0" /><span>{[current.address, current.postal_city].filter(Boolean).join(", ")}</span></li>}
            {current?.phone && <li className="flex items-center gap-2"><Phone size={16} className="text-hp-gold shrink-0" /><a href={`tel:${current.phone.replace(/\s/g,"")}`} className="hover:text-white">{current.phone}</a></li>}
            <li className="flex items-center gap-2"><Mail size={16} className="text-hp-gold shrink-0" /><a href={`mailto:${current?.email || "direction@horsepower-garage.fr"}`} className="hover:text-white">{current?.email || "direction@horsepower-garage.fr"}</a></li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 pb-10" data-testid="footer-brands">
        <h4 className="font-display uppercase text-sm tracking-widest text-hp-gold mb-4">Reprogrammation par marque</h4>
        <div className="flex flex-wrap gap-x-4 gap-y-2 text-xs text-white/50 font-light3">
          {[["audi", "Audi"], ["bmw", "BMW"], ["mercedes", "Mercedes"], ["volkswagen", "Volkswagen"], ["porsche", "Porsche"], ["peugeot", "Peugeot"], ["renault", "Renault"], ["ford", "Ford"], ["seat", "Seat"], ["skoda", "Skoda"], ["toyota", "Toyota"], ["alpine", "Alpine"], ["ferrari", "Ferrari"], ["lamborghini", "Lamborghini"], ["land-rover", "Land Rover"], ["cupra", "Cupra"]].map(([s, n]) => (
            <Link key={s} to={`/reprogrammation-moteur/${s}`} className="hover:text-hp-yellow">Reprogrammation {n}</Link>
          ))}
          <Link to="/reprogrammation-moteur" className="text-hp-gold hover:text-hp-yellow font-bold">Toutes les marques →</Link>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-white/40 font-light3">
        © {new Date().getFullYear()} Horsepower Garage — Réseau national de reprogrammation moteur. Tous droits réservés.
        <span className="block mt-2 space-x-3" data-testid="footer-legal">
          <Link to="/mentions-legales" className="hover:text-hp-yellow">Mentions légales</Link><span>·</span>
          <Link to="/confidentialite" className="hover:text-hp-yellow">Confidentialité</Link><span>·</span>
          <Link to="/cgv" className="hover:text-hp-yellow">CGV Boutique</Link>
        </span>
      </div>
    </footer>
  );
}
